import { render } from "./IconLoading.vue?vue&type=template&id=5adea562&scoped=true"
const script = {}

import "./IconLoading.vue?vue&type=style&index=0&id=5adea562&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5adea562"]])

export default __exports__